import React, { use, useEffect, useState, lazy, useRef, Suspense } from "react";
import commonapihandler from "../../common/commonapihandler";
import {
  getBlockVehicleDetails,
  getBlockedVehicleExtensionDetails,
  getVehicle,
  getBlockVehicleHistory,
  getSystemUserList,
} from "../../api/api";
import formatDateAndTime from "../../common/formatDateAndTime";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import Fieldscommonmodal from "../../common/Fieldscommonmodal";
import toast from "react-hot-toast";
import fileUpload from "../../common/fileupload";
import moment from "moment";
import Commonmodal from "../../common/Commonmodal";

const Viewblockdetails = ({ selectedRow, setActiveTabIndex }) => {
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  let VehicleStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleStatus;
  let fuelTypeVehicle = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.fuelType;
  let vehicleBodyType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleBodyType;
  const vehicleBlockType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.vehicleBlockType;
  const blockRequestTypes = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.blockRequestTypes;
  const fileInputRef = useRef(null);
  const profile = JSON.parse(localStorage.getItem("profile"));
  const [comment, setComment] = useState(null);
  const [imageData, setImageData] = useState(null);
  const [vehicleBlockData, setVehicleBlockData] = useState(null);
  const [blockedVehicleExtensionData, setBlockedVehicleExtensionData] =
    useState(null);
  const [vehicleData, setVehicleData] = useState(null);
  const [vehicleBlockHistory, setVehicleBlockHistory] = useState([]);
  const [image, setImage] = useState(null);
  const [systemUserList, setSystemUserList] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [editType, setEditType] = useState(null);
  const [form, setForm] = useState({
    currentOdometer: null,
  });
  const [error, setError] = useState("");
  const [openImageModal, setImageModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [affectedBookings, setAffectedBookings] = useState([]);
  const [blockedVehciles, setBlockedVehicles] = useState([]);

  const handleModalClose = () => {
    setForm({
      currentOdometer: null,
    });
    setOpenModal(false);
    setBlockedVehicles([]);
    setError("");
  };

  const handleModalOpen = () => {
    setOpenModal(true);
  };

  const handleImageClose = () => {
    setSelectedImage(null);
    setImageModal(false);
  };

  const handleImageOpen = (url) => {
    setSelectedImage(url);
    setImageModal(true);
  };

  useEffect(() => {
    const endDateTime = vehicleBlockData?.endDate;

    const enddate = endDateTime ? endDateTime.split(" ")[0] : "";
    const endtime = endDateTime ? endDateTime.split(" ")[1]?.slice(0, 5) : "";

    setForm({
      currentOdometer: vehicleBlockData?.initialOdometer || "",
      status: vehicleData?.status || "",
      vehicle: vehicleData?.name || "",
      startdate: enddate, // ✅ date
      starttime: endtime, // ✅ time
    });
  }, [openModal]);

  const vehicleDetailsBlockExtensionFields = [
    {
      label: "Start Date",
      value: "startdate",
      type: "date",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Start Time",
      value: "starttime",
      type: "time",
      disabled: false,
      subCategory: null,
    },
    {
      label: "End Date",
      value: "enddate",
      type: "date",
      disabled: false,
      subCategory: null,
    },
    {
      label: "End Time",
      value: "endtime",
      type: "time",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Vehicle",
      value: "vehicle",
      type: "text",
      disabled: true,
      subCategory: null,
    },
    {
      label: "Current Odometer",
      value: "currentOdometer",
      type: "number",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Block Type",
      value: "blocktype",
      type: "dropdown",
      disabled: false,
      subCategory: Object.entries(vehicleBlockType).map(([key, value]) => ({
        value: value,
        item: key,
      })),
    },
    {
      label: "Comment",
      value: "comment",
      type: "text",
      disabled: false,
      subCategory: null,
    },
    {
      label: "Upload Image",
      value: "uploadImage",
      type: "file",
      disabled: false,
      subCategory: null,
    },
  ];

  const getBlockVehicleDataApi = async (id) => {
    const apiDetails = await getBlockVehicleDetails(id);
    const response = await commonapihandler(
      apiDetails?.apiUrl,
      apiDetails?.method,
    );
    if (response?.statusCode === "0100") {
      setVehicleBlockData(response?.entityValue);
      await getBlockedVehicleExtensionDetailsAPI(response?.entityValue?.id);
      await getVehicleApi(response?.entityValue?.vehicleId);
    }
  };

  const getBlockedVehicleExtensionDetailsAPI = async (id) => {
    const apiDetails = await getBlockedVehicleExtensionDetails(id);
    const response = await commonapihandler(
      apiDetails?.apiUrl,
      apiDetails?.method,
    );
    if (response?.statusCode === "0100") {
      setBlockedVehicleExtensionData(response?.entities?.rows);
    }
  };

  const getVehicleApi = async (id) => {
    const apiDetails = await getVehicle(id);
    const response = await commonapihandler(
      apiDetails?.apiUrl,
      apiDetails?.method,
    );
    if (response?.statusCode === "0100") {
      setVehicleData(response?.entityValue);
    }
  };

  const getBlockVehicleHistoryAPI = async (id) => {
    const apiDetails = await getBlockVehicleHistory(id);
    const response = await commonapihandler(
      apiDetails?.apiUrl,
      apiDetails?.method,
    );
    if (response?.statusCode === "0100") {
      setVehicleBlockHistory(response?.entities?.rows);
    }
  };

  const getSystemUserAPI = async (id) => {
    const apiDetails = await getSystemUserList(id);
    const response = await commonapihandler(
      apiDetails?.apiUrl,
      apiDetails?.method,
    );
    if (response?.statusCode === "0100") {
      setSystemUserList(response?.entities?.rows);
    }
  };

  const attachmentUpload = async (event) => {
    const files = event.target.files;
    const formData = new FormData();
    formData.append("entityName", "vehicles");
    formData.append("fileTags", "booking-comments");
    Object.values(files).forEach((file) => {
      formData.append("files", file);
    });

    try {
      const response = await fetch(`${apiUrl}/fileapi/upload`, {
        method: "POST",
        body: formData,
      });
      const data = await response.json();
      if (data) {
        setImageData(data?.uploaded);
        setImage(data?.uploaded[0]?.url);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Hub Names:", error);
    }
  };

  const postComment = async (id) => {
    try {
      const response = await fetch(`${apiUrl}/api/blockedvehiclehistories`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          blockId: vehicleBlockData?.id,
          comment: comment,
          attachments: JSON.stringify(imageData),
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setComment("");
        setImageData(null);
        setImage(null);
        await getBlockVehicleHistoryAPI(vehicleBlockData?.id);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Users List:", error);
    }
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const UpdateVehicleDetails = async () => {
    if (blockedVehciles?.length > 0) {
      return toast?.error(
        "Already this vehicle is blocked on the specific duration",
        {
          position: "bottom-center",
          style: {
            background: "white", // override background
            color: "red",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        },
      );
    }
    try {
      const response = await fetch(`${apiUrl}/api/blockvehicleextns`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          blockId: vehicleBlockData?.id,
          blocktype: form?.blocktype,
          oldEndDate: moment(vehicleBlockData?.endDate).format(
            "YYYY-MM-DDTHH:mm",
          ),
          newStartDate: form?.startdate + "T" + form?.starttime,
          newEndDate: form?.enddate + "T" + form?.endtime,
          reason: form?.comment,
          attachments: JSON.stringify(form?.uploadImage),
          extByName: profile?.name,
          extByEmail: profile?.email,
          extBy: profile?.id,
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setForm({
          currentOdometer: null,
        });
        setOpenModal(false);
        toast.success("Vehicle Changes Updated successfully.", {
          position: "bottom-center",
          style: {
            background: "blue", // override background
            color: "white",
            fontWeight: "medium",
            marginBottom: "50px",
          },
        });
        getBlockVehicleDataApi(vehicleBlockData?.id);
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching POST vehicle details:", error);
    }
  };

  const handleChange = async (field, value) => {
    if (field === "uploadImage") {
      await fileUpload(value, "vehicles", "vehicle").then((res) => {
        setForm((prev) => ({
          ...prev,
          [field]: res || "",
        }));
      });
      return;
    }

    setForm((prev) => {
      const nextForm = { ...prev, [field]: value };

      if (field === "startdate" || field === "starttime") {
        nextForm.enddate = "";
        nextForm.endtime = "";
      }

      return nextForm;
    });
  };

  useEffect(() => {
    if (selectedRow?.vehicleId) {
      getBlockVehicleDataApi(selectedRow?.id);
      getBlockVehicleHistoryAPI(selectedRow?.id);
      getSystemUserAPI(1);
    }
  }, [selectedRow]);

  const getAttachmentUrls = (attachments) => {
    if (!attachments) return [];

    let parsed = [];
    try {
      parsed = JSON.parse(attachments); // parse JSON string
    } catch {
      return [];
    }

    // Ensure it's always an array
    if (!Array.isArray(parsed)) parsed = [parsed];

    // Extract URL from known keys
    return parsed.map((att) => att.Location || att.path || att.url);
  };

  const getaffectedbookings = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/bookings/getbookingbydates?startDate=${
          form?.startdate + "T" + form?.starttime
        }&endDate=${form?.enddate + "T" + form?.endtime}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        const filtered = data?.dataValues?.filter(
          (item) => String(item.vehicleId) === String(vehicleData?.id),
        );
        setAffectedBookings(filtered);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Affected Bookings:", error);
    }
  };

  const getaffectedBlockings = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/blockedvehicles/blocklistbyvehicle?vehicleId=${vehicleBlockData?.vehicleId}&startDate=${
          form?.startdate + "T" + form?.starttime
        }&endDate=${form?.enddate + "T" + form?.endtime}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            Authorization: `${token}`,
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setBlockedVehicles(data?.dataValues);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Affected Bookings:", error);
    }
  };

  useEffect(() => {
    if (form?.startdate && form?.starttime && form?.enddate && form?.endtime) {
      getaffectedbookings();
      getaffectedBlockings();
    }
  }, [form?.enddate, form?.endtime]);

  return (
    <>
      {openModal && (
        <>
          <Fieldscommonmodal
            open={openModal}
            onClose={handleModalClose}
            textfields={
              editType === "block extension"
                ? vehicleDetailsBlockExtensionFields
                : ""
            }
            UpdateVehicleDetails={UpdateVehicleDetails}
            form={form}
            handleChange={handleChange}
            setForm={setForm}
            selectedRow={selectedRow}
            error={error}
            affectedBookings={affectedBookings}
            blockedVehciles={blockedVehciles}
          />
        </>
      )}

      {openImageModal && (
        <>
          <Commonmodal
            open={handleImageOpen}
            onClose={handleImageClose}
            url={selectedImage}
          />
        </>
      )}

      <div id="bookingdetailstabid">
        <div className="max-w-screen-2xl mx-auto py-4 h-screen overflow-y-scroll scrollbar-hide text-gray-900">
          <div className="bg-gradient-to-r from-gray-800 to-gray-700 text-white p-6 rounded-t-2xl flex flex-col md:flex-row justify-between items-start md:items-center gap-4 shadow-lg">
            <div>
              <h1 className="text-2xl font-bold">
                {vehicleData?.name + "-" + vehicleData?.vehicleModelText}
              </h1>
              <p className="text-sm opacity-80">Vehicle Mangement </p>
            </div>
            <div className="flex gap-3 flex-wrap">
              {!vehicleBlockData?.isUnblocked && (
                <div className="flex justify-end gap-3">
                  <button
                    onClick={() => {
                      setOpenModal(true);
                      setEditType("block extension");
                    }}
                    className="px-5 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700"
                  >
                    Block Extension
                  </button>
                  {/* <button onClick={() => {setEditType("unblock")}} className="px-5 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700">
                  Unblock
                </button> */}
                </div>
              )}
              <button
                onClick={() => {
                  setActiveTabIndex(0);

                  window.history.replaceState({}, "", window.location.pathname);
                }}
                class="bg-white text-center w-56 rounded-2xl h-14 relative text-black text-xl font-semibold group"
                type="button"
              >
                <div class="bg-green-400 rounded-xl h-12 w-1/4 flex items-center justify-center absolute left-1 top-[4px] group-hover:w-[194px] z-10 duration-500">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 1024 1024"
                    height="25px"
                    width="25px"
                  >
                    <path
                      d="M224 480h640a32 32 0 1 1 0 64H224a32 32 0 0 1 0-64z"
                      fill="#000000"
                    ></path>
                    <path
                      d="m237.248 512 265.408 265.344a32 32 0 0 1-45.312 45.312l-288-288a32 32 0 0 1 0-45.312l288-288a32 32 0 1 1 45.312 45.312L237.248 512z"
                      fill="#000000"
                    ></path>
                  </svg>
                </div>
                <p class="translate-x-2">Go Back</p>
              </button>
            </div>
          </div>

          <div className="max-w-screen-2xl mx-auto bg-gray-50 rounded-2xl shadow-xl p-6 mt-4">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {/* Vehicle Image */}
              <div className="flex justify-center items-center">
                <img
                  src={vehicleData?.imageUrl}
                  alt={vehicleData?.name}
                  className="w-full max-w-xs h-48 object-cover rounded-xl border shadow-sm"
                />
              </div>

              {/* Vehicle Details */}
              <div className="md:col-span-2 grid grid-cols-1 sm:grid-cols-4 gap-4">
                <Detail label="Vehicle Name" value={vehicleData?.name} />
                <Detail label="Model" value={vehicleData?.vehicleModelText} />
                <Detail label="Group" value={vehicleData?.vehicleGroupText} />
                <Detail
                  label="Registration Number"
                  value={vehicleData?.licensePlate}
                />
                <Detail
                  label="Fuel Type"
                  value={fuelTypeVehicle[vehicleData?.fuelType]}
                />
                <Detail
                  label="Vehicle Body Type"
                  value={vehicleBodyType[vehicleData?.vehicleBodyType]}
                />
                <Detail
                  label="Seating Capacity"
                  value={`${vehicleData?.seater} Seater`}
                />
                <Detail
                  label="Block Start Date"
                  value={formatDateAndTime(vehicleBlockData?.startDate)}
                />
                <Detail
                  label="Block End Date"
                  value={formatDateAndTime(vehicleBlockData?.endDate)}
                />
                <Detail
                  label="Total Blocked Days"
                  value={moment(vehicleBlockData?.endDate).diff(
                    moment(vehicleBlockData?.startDate),
                    "days",
                  )}
                />
                <Detail
                  label="Block Request By"
                  value={blockRequestTypes[vehicleBlockData?.blockRequest]}
                />
                <Detail
                  label="Type of Block"
                  value={vehicleBlockType[vehicleBlockData?.blockType]}
                />
                <Detail
                  label="Reason for Block"
                  value={vehicleBlockData?.comment}
                />
                {vehicleBlockData?.unblockedByDetails && (
                  <>
                    <Detail
                      label="Unblocked By"
                      value={
                        vehicleBlockData?.unblockedByDetails?.name || "N/A"
                      }
                    />
                    <Detail
                      label="Unblocked Date"
                      value={vehicleBlockData?.unblockDate || "N/A"}
                    />{" "}
                  </>
                )}

                {/* Attachments */}
                <div className="flex items-center gap-4 mt-2">
                  {/* {vehicleBlockData?.odometerImages && (
                    <img
                      onClick={() => {
                        handleImageOpen(vehicleBlockData?.odometerImages?.url);
                      }}
                      src={vehicleBlockData?.odometerImages?.url}
                      alt="odometer"
                      className="w-20 h-20 object-cover rounded-lg border shadow-sm cursor-pointer"
                    />
                  )} */}

                  {getAttachmentUrls(vehicleBlockData?.odometerImages).map(
                    (url, index) => (
                      <img
                        onClick={() => {
                          handleImageOpen(url);
                        }}
                        key={index}
                        src={url}
                        alt={`attachment-${index}`}
                        className="w-20 h-20 rounded-lg border object-cover cursor-pointer"
                      />
                    ),
                  )}

                  {getAttachmentUrls(vehicleBlockData?.attachments).map(
                    (url, index) => (
                      <img
                        onClick={() => {
                          handleImageOpen(url);
                        }}
                        key={index}
                        src={url}
                        alt={`attachment-${index}`}
                        className="w-20 h-20 rounded-lg border object-cover cursor-pointer"
                      />
                    ),
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="scrollbar-hide grid grid-cols-12 bg-gray-50 mt-4 rounded-xl shadow-lg overflow-y-scroll h-[700px]">
            <div className="col-span-7 bg-white border-r">
              <div className="h-full overflow-y-auto p-6">
                <h1 className="text-lg font-semibold text-gray-800 mb-4">
                  Extension Details
                </h1>

                {blockedVehicleExtensionData?.length > 0 ? (
                  blockedVehicleExtensionData?.map((data) => (
                    <div
                      key={data?.id}
                      className="bg-gray-50 border rounded-lg p-4 mb-4"
                    >
                      <div className="grid grid-cols-1 sm:grid-cols-4 gap-4">
                        <Detail
                          label="Old End Date"
                          value={formatDateAndTime(data?.oldEndDate)}
                        />
                        <Detail
                          label="New End Date"
                          value={formatDateAndTime(data?.newEndDate)}
                        />
                        <Detail label="Extended By" value={data?.extByName} />
                        <Detail label="Comment" value={data?.reason} />
                        <div>
                          <p className="text-sm text-gray-500 mb-1">
                            Attachments
                          </p>
                          <div className="flex gap-2">
                            {getAttachmentUrls(data?.attachments).map(
                              (url, index) => (
                                <img
                                  onClick={() => {
                                    handleImageOpen(url);
                                  }}
                                  key={index}
                                  src={url}
                                  alt={`attachment-${index}`}
                                  className="w-20 h-20 rounded-lg border object-cover cursor-pointer"
                                />
                              ),
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  ))
                ) : (
                  <p className="text-center text-gray-500 mt-10">
                    No Extension Details
                  </p>
                )}
              </div>
            </div>

            <div className="col-span-5 flex flex-col bg-white">
              <div className="p-4 border-b flex justify-between items-center">
                <h2 className="text-lg font-semibold text-gray-800">
                  Comments
                </h2>
              </div>

              <div className="flex-1 overflow-y-auto p-4 space-y-6 bg-gray-50">
                <div className="flex justify-center">
                  <span className="text-xs text-gray-600 px-4 py-1 bg-gray-200 rounded-full">
                    {new Date().toLocaleDateString("en-US", {
                      year: "numeric",
                      month: "long",
                      day: "numeric",
                    })}
                  </span>
                </div>

                {Array.isArray(vehicleBlockHistory) &&
                vehicleBlockHistory.length > 0 ? (
                  vehicleBlockHistory.map((message, index) => {
                    const isMyComment = message?.createdBy === profile?.id;

                    let attachments = [];
                    if (typeof message?.attachments === "string") {
                      try {
                        const parsed = JSON.parse(message.attachments);
                        attachments = Array.isArray(parsed) ? parsed : [];
                      } catch {
                        attachments = [];
                      }
                    } else if (Array.isArray(message?.attachments)) {
                      attachments = message.attachments;
                    }

                    return (
                      <div
                        key={index}
                        className={`flex flex-col ${
                          isMyComment ? "items-end" : "items-start"
                        }`}
                      >
                        <div
                          className={`px-4 py-3 rounded-xl max-w-[70%] text-sm shadow ${
                            isMyComment
                              ? "bg-blue-500 text-white rounded-br-none"
                              : "bg-white border text-gray-800 rounded-bl-none"
                          }`}
                        >
                          {attachments.length > 0 && attachments[0]?.url && (
                            <img
                              src={attachments[0].url || attachments[0].path}
                              onClick={() => {
                                handleImageOpen(
                                  attachments[0].url || attachments[0].path,
                                );
                              }}
                              alt="attachment"
                              className="w-48 h-44 rounded-lg mb-2 object-cover border cursor-pointer"
                            />
                          )}
                          {message?.comment}
                        </div>

                        <div className="text-[11px] text-gray-500 mt-1">
                          {
                            systemUserList.find(
                              (item) => item?.id === message?.createdBy,
                            )?.name
                          }{" "}
                          • {formatDateAndTime(message?.updatedAt)}
                        </div>
                      </div>
                    );
                  })
                ) : (
                  <p className="text-center text-gray-500 mt-10">No Comments</p>
                )}
              </div>

              <div className="p-4 border-t bg-white flex items-center gap-3">
                {image && (
                  <img
                    src={image}
                    onClick={() => {
                      handleImageOpen(image);
                    }}
                    className="h-16 w-16 rounded-lg border object-cover cursor-pointer"
                  />
                )}

                <input
                  type="file"
                  ref={fileInputRef}
                  className="hidden"
                  onChange={attachmentUpload}
                />

                <button
                  onClick={handleClick}
                  className="p-2 rounded-full hover:bg-gray-200"
                >
                  <AttachFileIcon />
                </button>

                <input
                  type="text"
                  value={comment}
                  onChange={(e) => setComment(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      e.preventDefault();
                      postComment();
                    }
                  }}
                  placeholder="Type a message..."
                  className="flex-1 border rounded-full px-4 py-2 focus:ring-2 focus:ring-blue-400 outline-none"
                />

                <button
                  onClick={postComment}
                  className="bg-blue-500 hover:bg-blue-600 text-white px-5 py-2 rounded-full shadow"
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const Detail = ({ label, value }) => (
  <div>
    <p className="text-sm text-gray-500">{label}</p>
    <p className="font-medium text-gray-800">{value}</p>
  </div>
);

export default Viewblockdetails;
